
'use strict';

const Util = {

    $pageWrapper: $('c:page-wrapper'),

    // Breakpoints
    breakPoints: {
        'xs' : 0,
        'sm' : 576,
        'md' : 768,
        'lg' : 992,
        'xl' : 1200,
    },

    currentBreakPoint: 'xs',

    // viewport
    viewport:'mobile',

    setScreenType() {

        const getViewport = function() {
            Util.viewport = window.getComputedStyle(document.body, ":after")
                .getPropertyValue('content')
                .replace(/[^0-9a-zA-Z]/g, "") || "mobile";
        };

        window.attachEvent ? window.attachEvent("onresize", function() {
            getViewport();
        }) : window.addEventListener && window.addEventListener("resize", function() {
            getViewport();
        }, true);
        getViewport();
    },

    listeners: [],

    /**
     * Add a listener to the object like this:
     *
     * ```
     * Util.addListener('resize', window, this.windowResizeListener = event => this.handleWindowResize(event));
     * Util.removeListener('resize', window, this.windowResizeListener);
     * ```
     *
     * @param evt
     * @param elem
     * @param fn
     */
    addListener(evt,elem,fn) {
        var callback = function callback(evt) {
            fn(evt,evt&&evt.target?evt.target:window.event.srcElement);
        };

        Util.listeners.push({
            evt:evt,
            elem:elem,
            fn:fn,
            callback:callback,
            removed:false
        });

        if (elem.addEventListener) {
            elem.addEventListener(evt, callback);
        }
        else if (elem.attachEvent) {
            elem.attachEvent('on' + evt,callback);
        }
        else {
            elem['on' + evt] = callback;
        }
    },

    removeListener(evt, elem, fn) {
        var callback;
        this.listeners.forEach(function(evtObj) {

            if (evtObj.evt === evt && evtObj.elem === elem && evtObj.fn === fn && !evtObj.removed) {
                evtObj.removed = true;
                callback = evtObj.callback;

                if (elem.removeEventListener) {
                    elem.removeEventListener(evt, callback);
                }
                else if (elem.detachEvent) {
                    elem.detachEvent('on' + evt, callback);
                }
                else {
                    delete elem['on' + evt];
                }

                return false;
            }
        });

        console.log(this.listeners);
    },

    /**
     * Init touch support test
     */
    hasTouchSupport: 'ontouchstart' in window||navigator.maxTouchPoints>0||navigator.msMaxTouchPoints>0,
    touchClass:'touch-device',
    noTouchClass:'no-touch-device',

    initFeatureTestClasses(){
        document.body.classList.add(this.hasTouchSupport?this.touchClass:this.noTouchClass);
        if(navigator.userAgent.indexOf('MSIE')>=0){
            document.body.classList.add('-ie10');
        }
    },

    isEditMode() {
        return !!document.querySelector('#ccm-toolbar');
    },

    /**
     * Detect CSS animation event
     * @returns {*}
     */
    whichAnimationEvent() {

        let t,
            el = document.createElement("fakeelement");

        let animations = {
            "animation"      : "animationend",
            "OAnimation"     : "oAnimationEnd",
            "MozAnimation"   : "animationend",
            "WebkitAnimation": "webkitAnimationEnd"
        };

        for (t in animations){
            if (el.style[t] !== undefined){
                return animations[t];
            }
        }
    },

    init() {
        this.setScreenType();
        this.initFeatureTestClasses();
    }
};
// Initialize Util script

Util.init();

// Export as module
export default Util;
